export default __webpack_public_path__ + "static/media/lamparas de mimbre y bambu.4c2979e7.jpg";